import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['sentinel', 'sticky'];

  connect() {
    this.observer = new IntersectionObserver(
      ([entry]) => {
        this.stickyTarget.classList.toggle('is-stuck', !entry.isIntersecting);
      },
      { threshold: 0 }
    );
    this.observer.observe(this.sentinelTarget);
  }

  disconnect() {
    if (this.observer) {
      this.observer.disconnect();
      this.observer = null;
    }
  }

  scrollToTop() {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }
}
